import { Link } from 'react-router-dom';
import { FeedbackMessage } from '../FeedbackMessage';
import { EmailField } from '../fields';
import type { AuthTemplateProps } from '../types';

export default function ForgotPasswordTemplate(props: AuthTemplateProps) {
    return (
        <section className="mx-auto max-w-lg space-y-4">
            <div className="p-8 bg-coconut rounded-lg space-y-5">
                <h1 className="text-2xl font-semibold">Reset your password</h1>
                <p className="text-base text-licorice">
                    Enter your email and we&apos;ll send a secure link to reset your password. If
                    your email is registered, you&apos;ll get instructions shortly.
                </p>
                <FeedbackMessage feedback={props.message} />
                <FeedbackMessage feedback={props.error} tone="error" />

                <form className="space-y-4" onSubmit={props.onSubmit} noValidate>
                    <EmailField {...props} />
                    <div className="flex items-center justify-start space-x-4">
                        <button type="submit" className="btn btn-solid-blueberry btn-md">
                            Send reset link
                        </button>
                        <Link
                            className="text-sm font-semibold underline decoration-dotted hover:no-underline"
                            to={props.authHref('login')}
                        >
                            Back to login
                        </Link>
                    </div>
                </form>
            </div>
        </section>
    );
}
